export default Object.freeze({
    LEGACY: 'LEGACY',
    PLAN: 'PLAN',
})
